import { format } from "date-fns";
import { it } from "date-fns/locale";
import { euro } from "@/lib/api";

const quando = (a) => `${format(new Date(`${a.data}T00:00`), "EEEE d MMMM", { locale: it })} alle ${a.ora}`;
const cosa = (a) => (a.area === "noleggio"
  ? `${a.tipo.toLowerCase()}${a.bici_desc ? ` (${a.bici_desc})` : ""}`
  : `${a.tipo.toLowerCase()}${a.bici_desc ? ` della tua ${a.bici_desc}` : ""}`);

export const messaggioConferma = (a, negozio) =>
  `Ciao ${a.cliente_nome.split(" ")[0]}, ti confermiamo l'appuntamento per ${cosa(a)} ${quando(a)}${negozio ? ` presso ${negozio}` : ""}. Se hai bisogno di spostarlo rispondi a questo messaggio. A presto!`;

export const messaggioPromemoria = (a, negozio) =>
  `Ciao ${a.cliente_nome.split(" ")[0]}, ti ricordiamo l'appuntamento di domani per ${cosa(a)}: ${quando(a)}${negozio ? ` presso ${negozio}` : ""}. Se non riesci a venire avvisaci rispondendo a questo messaggio. Grazie!`;

export const waPhone = (tel) => {
  let d = String(tel || "").replace(/[^\d+]/g, "");
  if (d.startsWith("+")) return d.slice(1);
  if (d.startsWith("00")) return d.slice(2);
  return d.length >= 9 && d.length <= 10 ? `39${d}` : d;
};

export const openWhatsApp = (tel, text = "") => {
  const p = waPhone(tel);
  window.open(`https://wa.me/${p}${text ? `?text=${encodeURIComponent(text)}` : ""}`, "_blank", "noopener");
};

export const messaggioScheda = ({ nome, bici, numero, stato, totale, negozio }) => {
  const shop = negozio || "la nostra officina";
  if (stato === "completato" || stato === "consegnato") {
    return `Ciao ${nome}, la tua bici ${bici} è pronta per il ritiro presso ${shop}! Totale: ${euro(totale)} (scheda #${numero}). Ti aspettiamo!`;
  }
  if (stato === "in_lavorazione") return `Ciao ${nome}, ti informiamo che stiamo lavorando sulla tua bici ${bici} (scheda #${numero}). Ti avviseremo appena sarà pronta. ${shop}`;
  return `Ciao ${nome}, abbiamo preso in carico la tua bici ${bici} (scheda #${numero}). Ti avviseremo appena sarà pronta. ${shop}`;
};
